<div class="container">
  <div class="offset-1 col-10">
    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Risk Management</h5>
                  <h2 class=" card-title"><i class="fas fa-random fa-lg"></i>&nbsp;&nbsp;&nbsp; Monte Carlo</h2>
                </div>
              </div>
            </div>
            <div class=" card-body">

              <div class="row">
                <div class="offset-1 col-10">
                  <p>Thanks to Monte Carlo simulations, you may model the probability of breaking the protection. In fact, when faced with significant uncertainty in the process of making a decision (forecast or estimation), the Monte Carlo simulations might prove to be a better solution by using multiple values.</p>
                </div>
                <div class="offset-1 col-10" style="line-height: 30px">
                  <div class="row">
                    <div class="col-6 text-right" style="line-height: 48px">
                      <span style="color: grey">What do you want to compare?</span>
                    </div>
                    <div class="col-6" style="line-height: 48px">
                      <mat-form-field>
                        <mat-select [(value)]="parameters.simulation_pivot" [disabled]="isComputing">
                          <mat-option value="aggressiveness">Aggressiveness</mat-option>
                          <mat-option value="maximum_loss">Max Loss</mat-option>
                          <mat-option value="maximum_drawdown">Max Drawdown</mat-option>
                          <mat-option value="protection_horizon">Protection Horizon</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-6">
                      <div class="w-100" style="border-top:1px dotted grey"></div>
                    </div>
                    <div class="col-6">
                      <div class="w-100" style="border-top:1px dotted grey"></div>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">Rebalancing Frequency</span>
                      <span class="float-right">
                        <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                          <mat-select [(value)]="parameters.rebalancing_frequency" [disabled]="isComputing">
                            <mat-option value="monthly">Monthly</mat-option>
                            <mat-option value="weekly">Weekly</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                    </div>
                    <div class="col-6" style="line-height: 30px">
                      <span style="color: grey">Risk Free Rate</span>
                      <span class="float-right">
                        <mat-form-field style="margin-top:-20px;margin-bottom:-20px;width:50px;">
                          <input matInput type="number" [(ngModel)]="parameters.risk_free_rate" [step]="0.1" [disabled]="isComputing">
                        </mat-form-field>
                        %
                      </span>
                    </div>
                    <div *ngIf="parameters.simulation_pivot!='aggressiveness'" class="col-6" style="line-height: 30px">
                      <div>
                        <span style="color: grey">Aggressiveness</span>
                        <span class="float-right">
                          <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                            <mat-select [(value)]="parameters.aggressiveness" [disabled]="isComputing">
                              <mat-option value="defensive">Defensive</mat-option>
                              <mat-option value="moderate">Moderate</mat-option>
                              <mat-option value="aggressive">Aggressive</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </span>
                      </div>
                    </div>
                    <div *ngIf="parameters.simulation_pivot!='protection_horizon'" class="col-6" style="line-height: 30px">
                      <span style="color: grey">Protection Horizon</span>
                      <span class="float-right">
                        <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                          <mat-select [(value)]="parameters.protection_horizon" [disabled]="isComputing">
                            <mat-option value="three_years">3 Years</mat-option>
                            <mat-option value="one_year">1 Year</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                    </div>
                    <div *ngIf="parameters.simulation_pivot!='maximum_loss' && parameters.simulation_pivot!='maximum_drawdown'" class="col-6" style="line-height: 30px">
                      <span class="float-left">
                        <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                          <mat-select [(value)]="parameters.target_type" [disabled]="isComputing">
                            <mat-option value="maximum_loss">Max Loss</mat-option>
                            <mat-option value="maximum_drawdown">Max Drawdown</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                      <span class="float-right">
                        <mat-form-field style="margin-top:-20px;margin-bottom:-20px;width:50px;">
                          <mat-select [(value)]="parameters.protection_level" [disabled]="isComputing">
                            <mat-option [value]="10">10</mat-option>
                            <mat-option [value]="20">20</mat-option>
                            <mat-option [value]="30">30</mat-option>
                          </mat-select>
                        </mat-form-field>
                        %
                      </span>
                    </div>
                    <div class="col-6">
                      <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                    </div>
                    <div class="col-6">
                      <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class=" card-footer">
              <div class="col-12 text-center">
                <app-button [disabled]="isComputing" (click)="onCompute()">Compute</app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class=" content" *ngIf="showResults && parameters.simulation_pivot==monteCarloSimulation.parameters.simulation_pivot">
    <br>
    <div class=" row">
      <div class=" col-12">
        <div class=" card card-chart">
          <div class=" card-header">
            <div class=" row">
              <div class=" col-sm-6 text-left">
                <h2 class=" card-title">Simulations</h2>
              </div>
            </div>
          </div>
          <div class=" card-body">
            <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
              <!--    .                                      -->
              <!--   / \   Do not change mat-tab labels.     -->
              <!--  / ! \  They are used in typescript code. -->
              <!-- /_____\                                   -->
              <mat-tab *ngIf="true" label="Gap Risk"></mat-tab>
              <mat-tab *ngIf="true" label="Returns"></mat-tab>
              <mat-tab *ngIf="true" label="Volatility"></mat-tab>
            </mat-tab-group>

            <br>
            <!-- Gap Risk bar chart -->
            <app-basic-bar-chart *ngIf="selectedTab=='Gap Risk'"
                                 [catNames]="['Gap Risk', 'Probability']"
                                 [catFields]="['gap_risk', 'probability']"
                                 [series]="pivotChartSeries[parameters.simulation_pivot].gap_risk" percent></app-basic-bar-chart>
            <!-- Gap Risk bar chart -->
            <!-- Returns bar chart -->
            <app-basic-bar-chart *ngIf="selectedTab=='Returns'" [series]="pivotChartSeries[parameters.simulation_pivot].returns" percent></app-basic-bar-chart>
            <!-- Returns bar chart -->
            <!-- Volatility bar chart -->
            <app-basic-bar-chart *ngIf="selectedTab=='Volatility'" [series]="pivotChartSeries[parameters.simulation_pivot].volatility" percent></app-basic-bar-chart>
            <!-- Volatility bar chart -->
          </div>
        </div>
      </div>
    </div>

    <div class=" content">
      <br>
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-12 text-center">
                  <h2 class=" card-title">{{ selectedTab }}</h2>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngFor="let pivot of ['aggressiveness','maximum_loss','maximum_drawdown','protection_horizon']" class="row">
                <div *ngIf="parameters.simulation_pivot==pivot" class="col-12">

                  <!-- Gap Risk table -->
                  <table *ngIf="selectedTab=='Gap Risk'" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ column.name }}</th>
                      <th *ngIf="pivotSubCategories[pivot].show_unprotected.gap_risk" scope="col">Unprotected</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th class="casino" scope="col" width="30%">Probability</th>
                      <td *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].gap_risk.probability | percent:'.2' }}</td>
                      <td *ngIf="pivotSubCategories[pivot].show_unprotected.gap_risk" scope="col">{{ monteCarloSimulation.unprotected.gap_risk.probability | percent:'.2' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" scope="col" width="30%">Gap Risk</th>
                      <td *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].gap_risk.gap_risk | percent:'.2' }}</td>
                      <td *ngIf="pivotSubCategories[pivot].show_unprotected.gap_risk" scope="col">{{ monteCarloSimulation.unprotected.gap_risk.gap_risk | percent:'.2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Gap Risk table -->

                  <!-- Returns table -->
                  <table *ngIf="selectedTab=='Returns'" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ column.name }}</th>
                      <th *ngIf="pivotSubCategories[pivot].show_unprotected.returns" scope="col">Unprotected</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th class="casino" scope="col" width="30%">Mean</th>
                      <td *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].returns.percentiles.mean | percent:'.1' }}</td>
                      <td *ngIf="pivotSubCategories[pivot].show_unprotected.returns" scope="col">{{ monteCarloSimulation.unprotected.returns.percentiles.mean | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" style="color: grey" scope="col" width="30%">Proba. > 95%</th>
                      <td style="color: grey" *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].returns.percentiles['95'] | percent:'.1' }}</td>
                      <td style="color: grey" *ngIf="pivotSubCategories[pivot].show_unprotected.returns" scope="col">{{ monteCarloSimulation.unprotected.returns.percentiles['95'] | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" style="color: grey" scope="col" width="30%">Proba. > 50%</th>
                      <td style="color: grey" *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].returns.percentiles.median | percent:'.1' }}</td>
                      <td style="color: grey" *ngIf="pivotSubCategories[pivot].show_unprotected.returns" scope="col">{{ monteCarloSimulation.unprotected.returns.percentiles.median | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" style="color: grey" scope="col" width="30%">Proba. > 5%</th>
                      <td style="color: grey" *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].returns.percentiles['5'] | percent:'.1' }}</td>
                      <td style="color: grey" *ngIf="pivotSubCategories[pivot].show_unprotected.returns" scope="col">{{ monteCarloSimulation.unprotected.returns.percentiles['5'] | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" scope="col" width="30%">Std Dev.</th>
                      <td *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].returns.percentiles.standard_deviation | percent:'.1' }}</td>
                      <td *ngIf="pivotSubCategories[pivot].show_unprotected.returns" scope="col">{{ monteCarloSimulation.unprotected.returns.percentiles.standard_deviation | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Returns table -->

                  <!-- Volatility table -->
                  <table *ngIf="selectedTab=='Volatility'" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ column.name }}</th>
                      <th *ngIf="pivotSubCategories[pivot].show_unprotected.volatility" scope="col">Unprotected</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th class="casino" scope="col" width="30%">Mean</th>
                      <td *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].volatility.percentiles.mean | percent:'.1' }}</td>
                      <td *ngIf="pivotSubCategories[pivot].show_unprotected.volatility" scope="col">{{ monteCarloSimulation.unprotected.volatility.percentiles.mean | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" style="color: grey" scope="col" width="30%">Proba. > 95%</th>
                      <td style="color: grey" *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].volatility.percentiles['95'] | percent:'.1' }}</td>
                      <td style="color: grey" *ngIf="pivotSubCategories[pivot].show_unprotected.volatility" scope="col">{{ monteCarloSimulation.unprotected.volatility.percentiles['95'] | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" style="color: grey" scope="col" width="30%">Proba. > 50%</th>
                      <td style="color: grey" *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].volatility.percentiles.median | percent:'.1' }}</td>
                      <td style="color: grey" *ngIf="pivotSubCategories[pivot].show_unprotected.volatility" scope="col">{{ monteCarloSimulation.unprotected.volatility.percentiles.median | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" style="color: grey" scope="col" width="30%">Proba. > 5%</th>
                      <td style="color: grey" *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].volatility.percentiles['5'] | percent:'.1' }}</td>
                      <td style="color: grey" *ngIf="pivotSubCategories[pivot].show_unprotected.volatility" scope="col">{{ monteCarloSimulation.unprotected.volatility.percentiles['5'] | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th class="casino" scope="col" width="30%">Std Dev.</th>
                      <td *ngFor="let column of pivotSubCategories[pivot].columns" scope="col">{{ monteCarloSimulation[pivot][column.key].volatility.percentiles.standard_deviation | percent:'.1' }}</td>
                      <td *ngIf="pivotSubCategories[pivot].show_unprotected.volatility" scope="col">{{ monteCarloSimulation.unprotected.volatility.percentiles.standard_deviation | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Volatility table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                    </em>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <br>

  </div>

</div>
